import { TactikSiteTopBar } from "../app/TactikSiteTopBar";
import CustomerBenefitsPage from "../../customer_account/BenefitsPage";

export default function StandaloneBenefitsPage(): JSX.Element {
  return (
    <CustomerBenefitsPage scope="standalone" topBar={<TactikSiteTopBar />} />
  );
}
